var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.parametersToRender, function(param, index) {
        return [
          _c(
            "div",
            {
              key: param.name,
              staticClass: "cf-node-properties__field",
              class: _vm.getFieldSize(param.name)
            },
            [
              !(param.type == "sub_type" && !param.isOptional) ||
              param.type === "list_multiselect"
                ? _c("label", { staticClass: "control-label" }, [
                    _vm._v("\n        " + _vm._s(param.displayName) + " "),
                    !param.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: param.description,
                          expression: "param.description",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass: "fa fa-question-circle m-l-5",
                      attrs: { "aria-hidden": "true" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              param.type === "list"
                ? _c("InputSelect", {
                    attrs: {
                      options: param.values,
                      required: !param.isOptional,
                      placeholder: param.defaultValue,
                      error: _vm.getFieldError(_vm.propertyErrors, param.name)
                    },
                    on: { input: _vm.updateSettings },
                    model: {
                      value: _vm.settingsCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.settingsCopy, param.name, $$v)
                      },
                      expression: "settingsCopy[param.name]"
                    }
                  })
                : param.type === "number"
                ? _c("InputNumber", {
                    attrs: {
                      required: !param.isOptional,
                      placeholder: param.defaultValue,
                      error: _vm.getFieldError(_vm.propertyErrors, param.name)
                    },
                    on: { input: _vm.inputChange },
                    model: {
                      value: _vm.settingsCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.settingsCopy, param.name, $$v)
                      },
                      expression: "settingsCopy[param.name]"
                    }
                  })
                : param.type === "string"
                ? _c("InputText", {
                    attrs: {
                      required: !param.isOptional,
                      placeholder: param.defaultValue,
                      error: _vm.getFieldError(_vm.propertyErrors, param.name)
                    },
                    on: { input: _vm.inputChange },
                    model: {
                      value: _vm.settingsCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.settingsCopy, param.name, $$v)
                      },
                      expression: "settingsCopy[param.name]"
                    }
                  })
                : param.type === "bool"
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "cf-node-properties__input" },
                      [
                        _c("nzToggle", {
                          on: { input: _vm.updateSettings },
                          model: {
                            value: _vm.settingsCopy[param.name],
                            callback: function($$v) {
                              _vm.$set(_vm.settingsCopy, param.name, $$v)
                            },
                            expression: "settingsCopy[param.name]"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : param.type === "sub_type" && param.isOptional
                ? _c(
                    "div",
                    { staticClass: "cf-node-properties__input" },
                    [
                      _c("nzToggle", {
                        on: { input: _vm.updateSettings },
                        model: {
                          value: _vm.settingsCopy[param.name].isEnabled,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.settingsCopy[param.name],
                              "isEnabled",
                              $$v
                            )
                          },
                          expression: "settingsCopy[param.name].isEnabled"
                        }
                      })
                    ],
                    1
                  )
                : param.type === "list_multiselect"
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "cf-node-properties__input m-b-15" },
                      [
                        _c("MultipleToggle", {
                          attrs: {
                            value: _vm.settingsCopy[param.name],
                            options: param.values,
                            "default-value": param.defaultValue
                          },
                          on: {
                            onToggle: $event => {
                              _vm.settingsCopy[param.name] = $event.value
                              _vm.updateSettings()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.getFilteredParameters(_vm.linkedParameters, param.name)
                      .length > 0
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("SubTypeProps", {
                              staticClass: "col-md-12",
                              attrs: {
                                value: _vm.settingsCopy,
                                parameters: _vm.getFilteredParameters(
                                  _vm.linkedParameters,
                                  param.name
                                ),
                                "property-errors": _vm.propertyErrors,
                                "parent-parameter-name": param.name
                              },
                              on: {
                                input: deepObject =>
                                  _vm.updateNested(
                                    deepObject,
                                    _vm.getFilteredParameters(
                                      _vm.linkedParameters,
                                      param.name
                                    )
                                  )
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showAudioParameter(param.name)
            ? _c("AudioComponent", {
                key: `audio-${param.name}-${index}`,
                attrs: {
                  params: param.parameters,
                  "parent-setting": param.name,
                  errors: _vm.propertyErrors,
                  settings: _vm.settingsCopy
                },
                on: { "update:settings": _vm.handleAudioSettingsUpdate }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.showAudioParameter(param.name) &&
          param.type === "sub_type" &&
          _vm.settingsCopy[param.name].isEnabled
            ? [
                _c("SubTypeProps", {
                  key: `subType-${index}`,
                  attrs: {
                    parameters: param.parameters,
                    "property-errors": _vm.propertyErrors,
                    "parent-parameter-name": param.name
                  },
                  on: { input: _vm.updateSettings },
                  model: {
                    value: _vm.settingsCopy[param.name],
                    callback: function($$v) {
                      _vm.$set(_vm.settingsCopy, param.name, $$v)
                    },
                    expression: "settingsCopy[param.name]"
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.getFilteredParameters(_vm.linkedParameters, param.name).length >
            0 && param.type === "bool"
            ? [
                _vm.getFilteredParameters(_vm.linkedParameters, param.name)
                  .length > 0
                  ? _c("SubTypeProps", {
                      key: `subType-${index}`,
                      attrs: {
                        value: _vm.settingsCopy,
                        parameters: _vm.getFilteredParameters(
                          _vm.linkedParameters,
                          param.name
                        ),
                        "property-errors": _vm.propertyErrors,
                        "parent-parameter-name": param.name,
                        subgroup: false
                      },
                      on: {
                        input: deepObject =>
                          _vm.updateNested(
                            deepObject,
                            _vm.getFilteredParameters(
                              _vm.linkedParameters,
                              param.name
                            )
                          )
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }